export const PHOTO_WIDTH = 1920;
export const PHOTO_HEIGHT = 1080;
export const OVERLAY_PATHS = new Array(20).fill(1).map((_, i) => `https://baywa-prod.s3-eu-central-1.amazonaws.com/overlays/${i + 1}.jpg`);
export const NORMAL_FORMAT = 'NORMAL_FORMAT';
export const SPECIAL_FORMAT = 'SPECIAL_FORMAT';
export const IMG_PREVIEW_ASPECT_RATIO = 0.75;
